export const getBarThickness = (labelCount: number, isMobile: boolean) => {
  if (labelCount > 120) return 1;
  if (labelCount > 108) return 2;
  if (labelCount > 96) return 3;
  if (labelCount > 84) return 4;
  if (labelCount > 72) return 5;
  if (labelCount > 60) return isMobile ? 5 : 7;
  if (labelCount > 48) return isMobile ? 6 : 9;
  if (labelCount > 36) return isMobile ? 8 : 11;
  if (labelCount > 24) return isMobile ? 10 : 14;
  return isMobile ? 17 : 20;
};
